import React, { useState, useEffect } from "react";
import { ReactDOM } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './Login.css';
// import { checkUserAccess } from "./Services/CommonLibrary";


const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [setImg, setSetImg] = useState("");
  const [company, setCompany] = useState("");
  const [user, setUser] = useState("");
  const nav = useNavigate();
  let isLoggedIn = localStorage.getItem('user');

  const [alertInfo, setAlertInfo] = useState({
    visible: false,
    cls: 'danger',
    msg: ''
  });
  const { visible, cls } = alertInfo;

  const onShowAlert = (msg) => {
    setAlertInfo({ ...alertInfo, ['visible']: true, ['msg']: msg });
  }

  const forgotNavigate = () => {
    nav('/forgot-password')
  }

  useEffect(() => {

    const domainName = window.location.hostname;
    axios.post('https://coachnhsapiv2.goqii.com/nhspatientmanagement/company_logo', {
      domain: domainName
    })
      .then(function (response) {
        setSetImg(response.data.data.logo);
        setCompany(response.data.data.companyId) 
        // setCompany(2)
        //1 for nhs 2 for derma //3  for adhd//

      })
      .catch(function (error) {
        console.log(error);
      });

    if (isLoggedIn > 0) {
      return nav('/program-list');
    }
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();

    axios.post('https://coachnhsapiv2.goqii.com/nhspatientmanagement/user_login', {
      accessEmail: username,
      accessPassword: password,
      company: company
    })
      .then(function (response) {
        //set the state of the user
        if (response.data.status == "1") {
          setUser(response.data)
          //  console.log(response.data.data.pmsUserId);
          // store the user in localStorage
          localStorage.setItem('uid', response.data.data.pmsUserId)
          localStorage.setItem('user', response.data.data.validUser)
          localStorage.setItem('authToken', response.data.data.verificationToken)
          localStorage.setItem('access', response.data.data.access)
          localStorage.setItem('isTestUser', response.data.data.isTestUser)
          localStorage.setItem('accessTab', response.data.data.tabs)
          localStorage.setItem('company', response.data.data.company)

          return nav('/program-list');
          //  console.log(response.data)
        } else if (response.data.status == "0") {
          onShowAlert(response.data.data.message);
          // console.log()
        }

      })
      .catch(function (error) {
        console.log(error);
      });



  };

  // if there's a user show the message below

  if (isLoggedIn > 0) {
    // alert(isLoggedIn);
    return nav('/program-list');
    // return <div>{user.name} is loggged in</div>;
  }



  // if there's no user, show the login form
  return (
    <section className="nhs-login-page">
      <div className="container">
        <div className="content">
          <div className="row">

            <div className="col-12 mb-5">
              {/* <h1>NHS Login</h1> */}
            </div>
            <div className="card px-0">
              <div className="card-body">
                <div className="row mb-5">
                  <div className="col-6 text-start">
                    <img src={("https://appcdn.goqii.com/storeimg/36561_1672304537.png")} alt="" style={{ height: "34px" }} className="img-fluid" />
                  </div>
                  <div className="col-6 text-end">
                    <img src={setImg} alt="" style={{ height: "34px" }} className="img-fluid" />
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  {visible ?
                    <div className={"text-" + alertInfo.cls + " form-floating mb-3"} role="alert">
                      {alertInfo.msg}
                    </div> : null}
                  <div className="form-floating mb-3">
                    <input
                      type="text" required
                      value={username}
                      placeholder="enter a username"
                      className="form-control"
                      onChange={({ target }) => setUsername(target.value)}
                    />
                    <label >Username</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="password" required
                      value={password}
                      placeholder="enter a password"
                      className="form-control"
                      onChange={({ target }) => setPassword(target.value)}
                      autoComplete="off"
                    />
                    <label >Password</label>
                  </div>
                  <button type="submit" className="btn btn-primary btn-login mb-3">Login</button>
                </form>
                <div className="col-12 text-center center">
                  <div style={{ color: '#4e52d0', lineHeight: '50px', cursor: 'pointer' }} onClick={forgotNavigate} ><b>Forgot Password</b></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;